import { paginatedTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, PickBySku } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

class Skus {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<PickBySku>> => {
    const response = await this.api.get('/shipments/pick-by-sku', config)
    return paginatedTransform(PickBySku)(response.data)
  }
}

export class Picking {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get skus() {
    const api = new Skus(this.api)
    Object.defineProperty(this, 'skus', { value: api })
    return api
  }
}
